import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect, Provider} from 'react-redux';
import store from 'store';
import {searchForSet} from '../actions';
import SearchField from 'components/SearchField';

const SetsSearchIntegrator = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    index: PropTypes.string.isRequired,
    query: PropTypes.string,
  },

  getDefaultProps() {
    return {
      query: '',
    };
  },

  componentDidMount() {
    if (this.props.query.length > 0) {
      this.props.dispatch(searchForSet(this.props.query, this.props.index));
    }
  },

  handleSearchChanged(query) {
    this.props.dispatch(searchForSet(query, this.props.index));
  },

  render() {
    return <SearchField value={this.props.query} onChange={this.handleSearchChanged} />;
  },
});

export default (props) => {
  const mapStateToProps = (state) => {
    return {query: state.searchForSet.query};
  };

  const Connected = connect(mapStateToProps)(SetsSearchIntegrator);

  return (
    <Provider store={store}>
      <Connected {...props} />
    </Provider>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/views/Sets/integrators/SetsSearchIntegrator.js